import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { BasicLayoutComponent } from 'app/common/layouts/basicLayout.component';
import { AuthGuard, PendingChangesGuard, PrepareGuard } from 'app/core/core.module';
import { SharedModule } from 'app/shared/shared.module';
import { InventoryProjectionOverviewComponent } from './inventory-projection-overview/inventory-projection-overview.component';
import { InventoryProjectionDetailComponent } from './inventory-projection-detail/inventory-projection-detail.component';

@NgModule({
    imports: [
        CommonModule,
        SharedModule,
        FormsModule,
        RouterModule.forChild([
            {
                path: 'projections',
                component: BasicLayoutComponent,
                children: [
                    { path: '', redirectTo: 'overview', pathMatch: 'full' },
                    { path: 'overview', component: InventoryProjectionOverviewComponent, data: { title: 'Inventory Projections' }, canActivate: [AuthGuard, PrepareGuard] },
                    {
                        path: ':id',
                        component: InventoryProjectionDetailComponent,
                        data: { title: 'Detail' },
                        canActivate: [AuthGuard, PrepareGuard],
                        canDeactivate: [PendingChangesGuard],
                    },
                ],
            },
        ]),
    ],
    declarations: [InventoryProjectionOverviewComponent, InventoryProjectionDetailComponent],
})
export class InventoryProjectionsModule {}
